import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Text } from '@appcues/component-library';

import { ExpandableText } from 'next/components/ui';
import { Footer, ResultsWrapper } from 'components/Insights/Common/Styled';
import TableOverlay from 'components/Insights/Explorer/Common/TableOverlay';
import {
  TableContainer,
  TableData,
  TableRow,
  TableWrapper,
} from 'components/Common/UI/Table/Styled';
import TableHeader from 'components/Insights/Common/TableHeader';
import SelectedEventLabel from 'components/Insights/Explorer/Chart/SelectedEventLabel';
import Pagination from 'components/Common/UI/Pagination/Pagination';

import UserProfileModalManager from './UserProfileModalManager';

export const Table = ({
  results,
  isEmpty,
  currentPage,
  totalResults,
  pageSize,
  orderByColumn,
  orderByDirection,
  onSort,
  onChangePage,
}) => (
  <>
    <ResultsWrapper>
      <TableOverlay isEmpty={isEmpty} results={results} type="events-by-user" />
      <TableContainer className="panel">
        <TableWrapper>
          <thead>
            <TableRow>
              <TableHeader
                width={262}
                sortedColumn={orderByColumn}
                sortDirection={orderByDirection}
              >
                User ID
              </TableHeader>
              <TableHeader
                width={218}
                accessor="name"
                sortedColumn={orderByColumn}
                sortDirection={orderByDirection}
              >
                Event Name
              </TableHeader>
              <TableHeader
                width={259}
                accessor="a:_identity:_currentPageUrl"
                sortedColumn={orderByColumn}
                sortDirection={orderByDirection}
                onClick={onSort}
              >
                URL
              </TableHeader>
              <TableHeader
                width={209}
                accessor="timestamp"
                sortedColumn={orderByColumn}
                sortDirection={orderByDirection}
                onClick={onSort}
              >
                Last Triggered
              </TableHeader>
            </TableRow>
          </thead>
          <tbody>
            {(results || []).map(
              ({
                user_id,
                name,
                flow_id,
                checklist_id,
                'a:_identity:_currentpageurl': url,
                timestamp,
                'a:_identity': profile,
              }) => (
                <TableRow key={timestamp}>
                  <TableData>
                    <UserProfileModalManager
                      userId={user_id}
                      identity={profile}
                      timestamp={timestamp}
                    >
                      {user_id}
                    </UserProfileModalManager>
                  </TableData>
                  <TableData>
                    <SelectedEventLabel
                      event={name}
                      id={flow_id || checklist_id}
                    />
                  </TableData>
                  <TableData>
                    {url ? (
                      <ExpandableText lines={2}>{url}</ExpandableText>
                    ) : (
                      '-'
                    )}
                  </TableData>
                  <TableData>{moment(timestamp).format('lll')}</TableData>
                </TableRow>
              )
            )}
          </tbody>
        </TableWrapper>
      </TableContainer>
    </ResultsWrapper>
    {results && results.length > 0 && (
      <Footer>
        <Pagination
          pageCount={Math.ceil(totalResults / pageSize)}
          currentIndex={currentPage}
          onChange={onChangePage}
        />
        <Text
          fontWeight="bold"
          position="absolute"
          top="calc(50% + 0.25em)"
          right={0}
        >
          Displaying {currentPage * pageSize + 1}-
          {Math.min(currentPage * pageSize + pageSize, totalResults)} of{' '}
          {totalResults}
        </Text>
      </Footer>
    )}
  </>
);

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      user_id: PropTypes.string,
      name: PropTypes.string,
      flow_id: PropTypes.string,
      checklist_id: PropTypes.string,
      'a:_identity:_currentPageUrl': PropTypes.string,
      timestamp: PropTypes.string,
      'a:_identity': PropTypes.objectOf(PropTypes.string),
    })
  ),
  currentPage: PropTypes.number,
  totalResults: PropTypes.number,
  pageSize: PropTypes.number,
  orderByColumn: PropTypes.string,
  orderByDirection: PropTypes.string,
  onSort: PropTypes.func,
  onChangePage: PropTypes.func,
};

export default Table;
